'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { track } from '@/lib/analytics';

/** Fires a PAGE_VIEW event on every route change. Renders nothing. */
export function PageViewTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) track('PAGE_VIEW', pathname);
  }, [pathname]);

  return null;
}
